import React, { Component } from "react";
import { connect } from "react-redux";
import {
  setMenuLeftContent,
  setMenuLeftIndex,
  setMenuLeftItemIndex,
  setMenuTopIndex
} from "../../../redux/actions/menuActions";

import Menu from "../Menu.basepdc";
import PdcsContainer from "../../../containers/metier/pdcs/PdcsContainer";

class ListPdcs extends Component {
  componentDidMount() {
    this.props.setMenuTopIndex("basepdc");
    this.props.setMenuLeftContent(Menu);
    this.props.setMenuLeftIndex("listpdcs");
    this.props.setMenuLeftItemIndex("");
  }

  render() {
    return <PdcsContainer></PdcsContainer>;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setMenuLeftIndex: index => {
      dispatch(setMenuLeftIndex(index));
    },
    setMenuLeftItemIndex: index => {
      dispatch(setMenuLeftItemIndex(index));
    },
    setMenuLeftContent: content => {
      dispatch(setMenuLeftContent(content));
    },
    setMenuTopIndex: index => {
      dispatch(setMenuTopIndex(index));
    }
  };
};
export default connect(null, mapDispatchToProps)(ListPdcs);



// WEBPACK FOOTER //
// src/pages/basepdc/listpdcs/Home.listpdcs.js